import { render, staticRenderFns } from "./LoginExternoApi.vue?vue&type=template&id=12f83de9&scoped=true&"
import script from "./LoginExternoApi.vue?vue&type=script&lang=js&"
export * from "./LoginExternoApi.vue?vue&type=script&lang=js&"
import style0 from "./LoginExternoApi.vue?vue&type=style&index=0&id=12f83de9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f83de9",
  null
  
)

export default component.exports